// import md5 from "./md5"

function requestWithToken(params) {
    var data = getSign(params.data);
    $.ajax({
        type: 'POST',
        url: params.url,
        data: data,
        dataType: 'JSON',
        success: function(res){
            params.success(res)
        },
        error: function(){
            params.error()
        }
    })
}

function uploadWithToken(params) {
  var data = getFormDataSign(params.data);
  $.ajax({
      type: 'POST',
      url: params.url,
      data: data,
      contentType: false,
      processData: false,
      mimeType: "multipart/form-data",
      dataType: 'JSON',
      success: function(res){
          params.success(res)
      },
      error: function(){
          params.error()
      }
  })
}

function uploadBase64WithToken(params) {
  var data = getFormDataBase64Sign(params.data);
  $.ajax({
      type: 'POST',
      url: params.url,
      data: data,
      contentType: false,
      processData: false,
      mimeType: "multipart/form-data",
      dataType: 'JSON',
      success: function(res){
          params.success(res)
      },
      error: function(){
          params.error()
      }
  })
}

function getSign (paramsObj) {
    // 接口固定参数
    var jsonrpc = "2.0";
    var timetamp = (new Date()).valueOf();
    var nonce = Math.random().toString(36).substr(2);
    var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
    var uid = localStorage.getItem('uid');
    var unid = localStorage.getItem('unid');
    if(uid==''||uid==null||uid==undefined){
        uid = ''
    }
    if(unid==''||unid==null||unid==undefined){
        unid = ''
    }
    // 生成加密参数
    var string1 = "";
    string1 = "jsonrpc=" + jsonrpc+ "&nonce=" + nonce + "&timetamp=" + timetamp + "&uid=" + uid + "&unid=" + unid + key;
    // 加密sign
    var sign = $.md5(string1);
  
    // 生成接口调用所需的固定参数
    var dataDef = {
      jsonrpc: jsonrpc,
      uid: uid,
      unid: unid,
      timetamp: timetamp,
      nonce: nonce,
      sign: sign
    }
  
    // 拼接接口需要用到的参数
    var data = {};
    if (paramsObj == undefined || paramsObj == null) {
      data = dataDef;
    } else {
      data = Object.assign(dataDef, paramsObj);
    }
    return data;
  }

  function getFormDataSign (paramsObj) {
    var formData = new FormData();
    // 接口固定参数
    var jsonrpc = "2.0";
    var timetamp = (new Date()).valueOf();
    var nonce = Math.random().toString(36).substr(2);
    var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
    var uid = localStorage.getItem('uid');
    var unid = localStorage.getItem('unid');
    if(uid==''||uid==null||uid==undefined){
        uid = ''
    }
    if(unid==''||unid==null||unid==undefined){
        unid = ''
    }
    // 生成加密参数
    var string1 = "";
    string1 = "jsonrpc=" + jsonrpc+ "&nonce=" + nonce + "&timetamp=" + timetamp + "&uid=" + uid + "&unid=" + unid + key;
    // 加密sign
    var sign = $.md5(string1);

    formData.append('jsonrpc',jsonrpc);
    formData.append('uid',uid);
    formData.append('unid',unid);
    formData.append('timetamp',timetamp);
    formData.append('nonce',nonce);
    formData.append('sign',sign);
    formData.append('imageFile',paramsObj.imageFile);

    return formData;
  }

  function getFormDataBase64Sign (paramsObj) {
    var formData = new FormData();
    // 接口固定参数
    var jsonrpc = "2.0";
    var timetamp = (new Date()).valueOf();
    var nonce = Math.random().toString(36).substr(2);
    var key = "zPVAVhZxHS2b9fAskODfZk28pYsNW8sd";
    var uid = localStorage.getItem('uid');
    var unid = localStorage.getItem('unid');
    if(uid==''||uid==null||uid==undefined){
        uid = ''
    }
    if(unid==''||unid==null||unid==undefined){
        unid = ''
    }
    // 生成加密参数
    var string1 = "";
    string1 = "jsonrpc=" + jsonrpc+ "&nonce=" + nonce + "&timetamp=" + timetamp + "&uid=" + uid + "&unid=" + unid + key;
    // 加密sign
    var sign = $.md5(string1);

    formData.append('jsonrpc',jsonrpc);
    formData.append('uid',uid);
    formData.append('unid',unid);
    formData.append('timetamp',timetamp);
    formData.append('nonce',nonce);
    formData.append('sign',sign);
    formData.append('imagebase64',paramsObj.imagebase64);

    return formData;
  }

export { requestWithToken,uploadWithToken,uploadBase64WithToken }